import { format24As12 } from '~/cynqueModules/utils/format24As12'

declare module 'vue' {
  interface ComponentCustomProperties {
    $format24As12(value: string | null): string | null
  }
}

// Thin plugin that exposes the pure `format24As12` formatter as `this.$format24As12`
// for templates. The logic lives in cynqueModules/utils/format24As12 so non-component
// code (e.g. TimeVTextField) can reuse it without the removed window.$nuxt global.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$format24As12 = format24As12
})
